import { render, staticRenderFns } from "./VideoCallCarousel.vue?vue&type=template&id=4a2016e0&"
import script from "./VideoCallCarousel.vue?vue&type=script&lang=js&"
export * from "./VideoCallCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports